import * as countries from 'i18n-iso-countries'

// Le center stocke « en » pour le Royaume-Uni, qui n'est pas un code ISO alpha-2
const ISO_CODES: Record<string, string> = { en: 'gb' }

export const getCountryLabel = (country: string, language: string): string => {
  return countries.getName(ISO_CODES[country] ?? country, language) ?? country
}
